import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionMenuComponent } from '../action-menu/action-menu.component';
import { formatDateDDMMYYYY } from '../../../utils/date.util';

@Component({
  selector: 'app-card-list',
  standalone: true,
  imports: [CommonModule, ActionMenuComponent],
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss'],
})
export class CardListComponent {
  @Input() data: any[] | { letters: any[] } = [];
  @Output() rowClick = new EventEmitter<any>();
  selectedRow: any;
  @Output() comment = new EventEmitter<any>();
  @Output() approve = new EventEmitter<any>();
  @Output() reject = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() auditLog = new EventEmitter<any>();
  @Output() documentNameClick = new EventEmitter<any>();
  auditDialogVisible: boolean = false;
  @Input() context: string = 'default';
  @Input() showActions: boolean = true; // Control action button visibility
  @Input() isArchivedView: boolean = false; // Control if viewing archived items
  @Input() getPermissionForRow?: (row: any) => number; // Function to get permission for a row

  onRowClick(row: any) {
    this.rowClick.emit(row);
  }
  get rows(): any[] {
    // If parent passed an array, just return it
    if (Array.isArray(this.data)) {
      return this.data;
    }
    // If parent passed { letters: [...] }
    if (this.data && 'letters' in this.data) {
      return this.data.letters;
    }
    return [];
  }
  onView(row: any) {
  }
  onApprove(data: any) {
    this.approve.emit(data);
  }
  onReject(data: any) {
    this.reject.emit(data);
  }
  // open modal
  onAuditLog(row: any) {
    this.auditLog.emit(row);
  }

  closeAuditLog() {
    this.auditDialogVisible = false;
    this.selectedRow = null;
  }

  onDelete(row: any): void {
    this.delete.emit(row);
  }
  onComment(row: any) {
    this.comment.emit(row);
  }
  onEdit(row: any): void {
    this.edit.emit(row);
  }

  onDocumentNameClick(row: any): void {
    this.documentNameClick.emit(row);
  }

  getDisplayName(row: any): string {
    // For user context, use fullName field
    if (this.context === 'users') {
      return row.fullName || 'Unknown User';
    }
    // For routing-slips context, use documentName field
    if (this.context === 'routing-slips') {
      return row.documentName || 'Unknown Document';
    }
    // For document context (letters), use documentName field
    return row.documentName || 'Unknown Document';
  }

  // Format date using the utility function
  formatDate(dateValue: any): string {
    return formatDateDDMMYYYY(dateValue);
  }
}
